import React, { useState, useEffect } from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import DailyBalanceSectionTitle from "./DailyBalanceSectionTitle";

import PrintDailyBalanceSummary from "./PrintDailyBalanceSummary";
import BalanceDataTables from "./DataTables";
import { tabHasRecords } from "./printSectionUtils";
import { buildPrintDocumentTitle, toShamsiDate, usePrintDocumentTitle } from "../parity/AriaReport";

const resolveReportDate = (dateParam) => {
  if (dateParam) return dateParam;
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

const DailyReportBalance = ({ match }) => {
  const { date: dateParam } = match.params;
  const date = resolveReportDate(dateParam);
  const shamsiDate = toShamsiDate(date);
  usePrintDocumentTitle(buildPrintDocumentTitle(["گزارش روزانه مالی", date, shamsiDate]));

  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];

  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState({});
  const [expenseTabs, setExpenseTabs] = useState([]);
  const [revenuesTabs, setRevenuesTabs] = useState([]);

  useEffect(() => {
    requestData();

    return () => setData({});
  }, []);

  const requestData = async () => {
    try {
      await db
        .getAll(`dashboard/finance/daily?date=${date}`)
        .then(({ data }) => {
          setData(data.summary || {});
          setTableData(data.data[0]);
          requestTabs(data.data[0]);
        });
    } catch ({ response }) {
      setData(response || {});
    }
  };

  const requestTabs = async (dailyData) => {
    const [revenueTypes, expenseTypes] = await Promise.all([
      db.getAll("revenues/types"),
      db.getAll("expenses/types"),
    ]);

    const revenueList = revenueTypes?.data?.data ?? [];
    const expenseList = expenseTypes?.data?.data ?? [];

    setRevenuesTabs(
      revenueList.filter((tab) =>
        tabHasRecords(tab.id, "revenue_type_id", dailyData)
      )
    );
    setExpenseTabs(
      expenseList.filter((tab) =>
        tabHasRecords(tab.id, "expense_type_id", dailyData)
      )
    );
  };

  const hasSectionData =
    revenuesTabs.length > 0 || expenseTabs.length > 0;

  return (
    <main className="main-print-wrapper daily-balance-print">
      <PrintHeader
        title={lbl.DailyReport}
        date={date}
        shamsiDate={shamsiDate}
        printHeadTexts={printHeadTexts}
      />
      <DailyBalanceSectionTitle mainTitle="بیلانس" noPageBreak />
      <PrintDailyBalanceSummary summary={data} />
      {!hasSectionData ? (
        <p className="daily-report-empty-note">برای این تاریخ داده‌ای ثبت نشده است.</p>
      ) : null}
      {revenuesTabs.map(({ id, name, name_en }) => (
        <div key={`revenue-${id}`} className="daily-balance-section">
          <DailyBalanceSectionTitle
            mainTitle={lbl.Revenues}
            subTitle={name}
            noPageBreak
          />
          <BalanceDataTables
            typeID={id}
            name={name_en}
            data={tableData?.revenues}
            typeName={"revenue_type_id"}
          />
        </div>
      ))}
      {expenseTabs.map(({ id, name, name_en }) => (
        <div key={`expense-${id}`} className="daily-balance-section">
          <DailyBalanceSectionTitle
            mainTitle={lbl.Expenses}
            subTitle={name}
            color="#b75555"
            noPageBreak
          />
          <BalanceDataTables
            typeID={id}
            name={name_en}
            data={tableData?.expenses}
            typeName={"expense_type_id"}
          />
        </div>
      ))}
    </main>
  );
};

export default DailyReportBalance;
